/* Odd Ritual — shop category filter (Barba-safe via document-level delegation) */
(function () {
  var FADE_OUT = 250; /* ms */
  var FADE_IN = 300;  /* ms */
  var busy = false;

  function all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* capture the site's Lenis instance (it lives in module scope) by tapping
     prototype methods the site calls on it — any call hands us `this` */
  (function captureLenis() {
    var L = window.Lenis && window.Lenis.prototype;
    if (!L || L.__orTapped) return;
    L.__orTapped = true;
    ['on', 'emit', 'resize', 'scrollTo', 'start'].forEach(function (m) {
      var orig = L[m];
      if (typeof orig !== 'function') return;
      L[m] = function () {
        window.__orLenis = this;
        return orig.apply(this, arguments);
      };
    });
  })();

  /* page height changes after filtering — recompute Lenis limits + ScrollTrigger
     so the page can scroll to its new bottom */
  function refreshScroll() {
    var l = window.__orLenis;
    try {
      if (l && typeof l.resize === 'function') l.resize();
      else window.dispatchEvent(new Event('resize'));
    } catch (err) {}
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
  }

  /* h-flip-style one-shot swap: old text slides down and out, new text drops in from above */
  function flipText(el, next) {
    if (el._flipTimer) {
      window.clearTimeout(el._flipTimer);
      el._flipTimer = null;
      el.textContent = el._flipTarget || el.textContent;
      el.style.height = '';
      el.style.overflow = '';
    }
    var cur = el.textContent;
    if (cur === next) return;
    el._flipTarget = next;
    el.style.height = el.offsetHeight + 'px'; /* lock the line so layout never moves */
    el.style.overflow = 'hidden';
    var col = document.createElement('span');
    col.style.display = 'block';
    col.style.transform = 'translateY(-50%)';
    var a = document.createElement('span');
    a.style.display = 'block';
    a.textContent = next;
    var b = document.createElement('span');
    b.style.display = 'block';
    b.textContent = cur;
    col.appendChild(a);
    col.appendChild(b);
    el.textContent = '';
    el.appendChild(col);
    void el.offsetHeight; /* reflow so the slide transitions */
    col.style.transition = 'transform 400ms cubic-bezier(0.32, 0.72, 0, 1)';
    col.style.transform = 'translateY(0)';
    el._flipTimer = window.setTimeout(function () {
      el.textContent = next;
      el.style.height = '';
      el.style.overflow = '';
      el._flipTimer = null;
    }, 450);
  }

  /* the site's counter counts hidden items too — re-assert the visible count on
     pre-filtered pages (initial load and after every Barba transition) */
  function fixCount(scope) {
    if (busy) return;
    var active = scope.querySelector('.shop-cat.is-active');
    var countEl = scope.querySelector('[count-items="total"]');
    if (!active || !countEl) return;
    var visible = all('.product-col_item', scope).filter(function (it) {
      return it.style.display !== 'none';
    }).length;
    if (!visible) return;
    var want = String(visible).padStart(2, '0');
    if (countEl.textContent !== want) countEl.textContent = want;
  }

  var totalWatch = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var n = muts[i].target;
      var el = n.nodeType === 3 ? n.parentElement : n;
      if (el && el.closest && el.closest('[count-items="total"]')) {
        fixCount(el.closest('[data-barba="container"]') || document);
        return;
      }
    }
  });
  totalWatch.observe(document.documentElement, { childList: true, characterData: true, subtree: true });

  if (document.readyState !== 'loading') fixCount(document);
  else document.addEventListener('DOMContentLoaded', function () { fixCount(document); });

  /* product page: keep the price blue only while the chosen variant is on sale.
     The adapter dispatches non-bubbling variation_found on the form — capture phase catches it. */
  document.addEventListener('variation_found', function (e) {
    var form = e.target;
    if (!form || !form.closest) return;
    var row = form.closest('[data-barba="container"]') || document;
    var now = row.querySelector('.single-price_flex [data-commerce-type="variation-price"]');
    if (!now) return;
    var v = e.detail && e.detail.variation;
    now.classList.toggle('product-price_now', !!(v && v.compare_at_price));
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.shop-cat') : null;
    if (!btn || busy || btn.classList.contains('is-active')) return;

    var cat = btn.getAttribute('data-cat') || 'all';
    var label = btn.getAttribute('data-label') || btn.textContent.trim();
    var scope = btn.closest('[data-barba="container"]') || document;

    var items = all('.product-col_item', scope);
    if (!items.length) return;
    busy = true;

    all('.shop-cat', scope).forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
    });

    var toHide = [], toShow = [], staying = 0;
    items.forEach(function (it) {
      var cats = (it.getAttribute('data-cats') || '').split(/\s+/);
      var match = cat === 'all' || cats.indexOf(cat) !== -1;
      var hidden = it.style.display === 'none';
      if (match && hidden) toShow.push(it);
      else if (match) staying++;
      else if (!hidden) toHide.push(it);
    });

    var title = scope.querySelector('[shop-filter="title"]');
    var countEl = scope.querySelector('[count-items="total"]');

    /* shareable URL: swap the address without reloading (keep Barba's history state) */
    try {
      if (window.history && history.replaceState) {
        history.replaceState(history.state, '', '/collections/' + cat);
        document.title = (cat === 'all' ? 'All' : label) + ' – oddritual';
      }
    } catch (err) {}

    function swap() {
      /* hide the faded-out items and reveal the new ones in the same frame — no jump */
      toHide.forEach(function (it) { it.style.display = 'none'; });
      toShow.forEach(function (it) { it.style.opacity = '0'; it.style.display = ''; });
      if (title) flipText(title, label);
      if (countEl) countEl.textContent = String(staying + toShow.length).padStart(2, '0');
      void document.body.offsetHeight; /* reflow so the fade-in transitions */
      window.setTimeout(function () {
        toShow.forEach(function (it) {
          it.style.transition = 'opacity ' + FADE_IN + 'ms ease';
          it.style.opacity = '1';
        });
        window.setTimeout(function () {
          toShow.forEach(function (it) {
            it.style.transition = '';
            it.style.opacity = '';
          });
          refreshScroll();
          window.setTimeout(refreshScroll, 350); /* second pass once layout fully settles */
          busy = false;
        }, FADE_IN + 60);
      }, 20);
    }

    if (toHide.length) {
      toHide.forEach(function (it) {
        it.style.transition = 'opacity ' + FADE_OUT + 'ms ease';
        it.style.opacity = '0';
      });
      window.setTimeout(function () {
        toHide.forEach(function (it) { it.style.transition = ''; });
        swap();
      }, FADE_OUT + 30);
    } else {
      swap();
    }
  });
})();
